<div class="filter-table" [ngSwitch]="fieldType">
  <div *ngSwitchCase="'options'">
    <div
      class="dropdown"
      [ngClass]="{
        'background-color': app.filter.isSelected(
          fieldId,
          app.filterHeaderTable.filters
        )
      }"
    >
      <input
        class="form-control dropdown-filter dropdown-toggle"
        data-bs-toggle="dropdown"
        onkeydown="return false"
        placeholder="{{
          app.filter.isSelected(fieldId, app.filterHeaderTable.filters)
            ? app.text.RM.filterApplied
            : app.text.RM.filter
        }}"
        (click)="app.filterTable.isDropdownOpen = true"
      />
      <button
        *ngIf="app.filter.isSelected(fieldId, app.filterHeaderTable.filters)"
        class="btn clear-dropdown"
      >
        <i class="fa fa-times icon-size" (click)="clearFilter(fieldId)"></i>
      </button>
      <div class="dropdown-menu dropdown-list">
        <div *ngFor="let option of app.filterTable.getOptions(fieldId)">
          <label class="checkbox-label" (click)="$event.stopPropagation()">
            <input
              #checkboxes
              type="checkbox"
              class="checkbox-input"
              value="{{ option }}"
              [checked]="
                app.filter.isChecked(
                  fieldId,
                  option,
                  app.filterHeaderTable.filters
                )
              "
              (click)="
                $event.stopPropagation();
                app.filterHeaderTable.filter(fieldId, option);
                closeDropdown()
              "
            />
            <span class="label">{{
              app.filterTree.getOptionText(fieldId, option)
            }}</span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <!-- when the type of the field is input -->
  <div *ngSwitchCase="'value'">
    <div
      class="input-group"
      [ngClass]="{
        'background-color': model[fieldId] != null && model[fieldId] !== ''
      }"
    >
      <input
        type="text"
        class="form-control input-filter"
        [(ngModel)]="model[fieldId]"
        (keydown)="checkKey($event, fieldId, model[fieldId])"
        placeholder="{{ app.text.RM.filter }}"
        (click)="app.filterTable.isDropdownOpen = false"
      />

      <button
        class="btn btn-sm p-1"
        *ngIf="model[fieldId]"
        (click)="clearFilter(fieldId)"
      >
        <i class="fa fa-times"></i>
      </button>

      <button class="btn btn-sm p-1">
        <i
          class="fa fa-search"
          (click)="app.filterHeaderTable.filter(fieldId, model[fieldId])"
        ></i>
      </button>
    </div>
  </div>

  <div *ngSwitchCase="'typeahead'">
    <div
      class="input-group"
      [ngClass]="{
        'background-color': model[fieldId] != null && model[fieldId] !== ''
      }"
    >
      <app-field
        [model]="model"
        [field]="fieldId"
        [showLabel]="false"
        [showMandatory]="true"
        [typeaheadPlaceholder]="app.text.RM.filter"
      >
      </app-field>
    </div>
  </div>
  <div *ngSwitchCase="'dateInterval'">
    <div
      class="dropdown"
      [ngClass]="{
        'background-color': app.filter.isSelected(
          fieldId,
          app.filterHeaderTable.filters
        )
      }"
    >
      <input
        type="text"
        class="form-control input-filter"
        [(ngModel)]="model[fieldId]"
        (keydown)="checkKey($event, fieldId, model[fieldId])"
        placeholder="{{
          app.filter.lastUpdatedOnIsSelected()
            ? app.text.RM.filterApplied
            : app.text.RM.filter
        }}"
        (click)="app.datesFilter.showComponent = true; $event.stopPropagation()"
      />
      <button
        *ngIf="app.filter.lastUpdatedOnIsSelected()"
        class="btn clear-dropdown"
      >
        <i
          class="fa fa-times icon-size"
          (click)="clearLastUpdatedOnFiter(fieldId)"
        ></i>
      </button>
    </div>
  </div>
</div>
